import { render, staticRenderFns } from "./TranslationBillingEdit.vue?vue&type=template&id=5c55c9f7"
import script from "./TranslationBillingEdit.vue?vue&type=script&lang=js"
export * from "./TranslationBillingEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports